import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertService } from '../Alert/alert.service';
import { Observable } from 'rxjs';
// import { environment2 } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private baseUrl = 'https://dashboard.fontana-pizzeria.com/api/';
  private payment = 'https://api2.authorize.net/xml/v1/request.api';
  // private baseUrl = environment2.backend.baseURL;
  private token = localStorage.getItem('fontana_token')?.toString();
  private now = 0

  
  constructor(private http: HttpClient,private router: Router,private alertService: AlertService) { }

  public checkExpiration() {
    const expDate = localStorage.getItem('fontana_expDate')
    // console.log(expDate)
    if (expDate) {
      this.now = Math.floor(Date.now() / 1000)
      if (this.now > parseInt(expDate) && this.token) {
        this.logout();
      }
    }
    return true;
  }
  public logout() {
    localStorage.removeItem('fontana_token')
    localStorage.removeItem('fontana_userName')
    localStorage.removeItem('fontana_expDate')
    localStorage.removeItem('fontana_userData')
    localStorage.removeItem('deliveryOption')
    localStorage.removeItem('selectedAddress')
    localStorage.removeItem('selectedLat')
    localStorage.removeItem('selectedLng')
    localStorage.removeItem('couponApplied')
    localStorage.removeItem('couponCode')
    localStorage.removeItem('couponType')
    localStorage.removeItem('couponValue')
    localStorage.removeItem('couponId')
    window.location.reload();
  }
  public signIn(body: any): Observable<any> {
    this.now = Math.floor(Date.now() / 1000);
    const header = {
      // 'Accept': 'application/json',
      // 'Content-Type': 'application/json',
      'lang': 'en'
    }
    return this.http.post(`${this.baseUrl}auth/login`, body, { headers: header });
  }
  public signUp(body: any): Observable<any> {
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'lang': 'en'
    }
    return this.http.post(`${this.baseUrl}auth/signup`, body, { headers: header });
  }
  public sendOtpToMailAfterSignup(body: any): Observable<any> {
    this.checkExpiration()
    const tokenToVerify = localStorage.getItem('fontana_token_to_verify')
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'locale': 'en',
      'Authorization': `Bearer ${tokenToVerify}`,
      'auth-token': `${tokenToVerify}`,
    });
    return this.http.post(`${this.baseUrl}my/profile/send_otp_to_custom_email`,body, {headers});
  }
  // public sendOtpToMail(body: any): Observable<any> {
  //   this.checkExpiration()
  //    const headers = new HttpHeaders({
  //     'Accept': 'application/json',
  //     'locale': 'en'
  //   });
  //   return this.http.post(`${this.baseUrl}auth/password/verify_otp`,body, {headers});
  // }
  public verifyOtpAfterSignup(body: any): Observable<any> {
    this.checkExpiration()
    const tokenToVerify = localStorage.getItem('fontana_token_to_verify')
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'locale': 'en',
      'Authorization': `Bearer ${tokenToVerify}`,
      'auth-token': `${tokenToVerify}`,
    });
    return this.http.post(`${this.baseUrl}my/profile/verify_otp`,body, {headers});
  }
  // Home page APIS
  public getHomePageData(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en'
    }
    return this.http.get(`${this.baseUrl}app/main`, { headers: header });
  }
  public getHomePageSubCategory(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en'
    }
    return this.http.get(`${this.baseUrl}app/category/sub-categories/3`, { headers: header });
  }
  public getHomePagePopularProducts(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en'
    }
    return this.http.get(`${this.baseUrl}app/popular-products`, { headers: header });
  }
  public getSubCategoryProducts(subCatId: number,pageNumber: number): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en',
      'auth-token': `${this.token}`
    }
    return this.http.get(`${this.baseUrl}app/sub-category/${subCatId}/products?page=${pageNumber}`, { headers: header });
  }
  public getAllCategories(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en',
      'auth-token': `${this.token}`
    }
    return this.http.get(`${this.baseUrl}app/main/categories`, { headers: header });
  }
  public getSubCategoryByCategoryId(categoryId: number): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en',
      'auth-token': `${this.token}`
    }
    return this.http.get(`${this.baseUrl}app/category/sub-categories/${categoryId}`, { headers: header });
  }
  public getSelectedProduct(productId: number): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en',
      'auth-token': `${this.token}`
    }
    return this.http.get(`${this.baseUrl}app/product/${productId}`, { headers: header });
  }

  // with token
  public toggleFavoriteProduct(productId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/favorites/product/toggle/${productId}`,null, {headers});
  }
  public myProfile(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/profile`, {headers});
  }
  public myOrders(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/orders`, {headers});
  }
  public myAddresses(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/addresses`, {headers});
  }
  public myProfileUpdate(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/profile/update`,body, {headers});
  }
  public changePassword(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/profile/password/change`,body, {headers});
  }
  public deleteAccount(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/profile/delete`, {headers});
  }
  public changeProfileImage(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/profile/image/update`,body, {headers});
  }
  public deleteProfileImage(): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/profile/image/remove`, {headers});
  }

  public reorderOrder(id: number): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/orders/reorder/${id}`,null, {headers});
  }

  public cancelOrder(id: number): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/orders/cancel/${id}`,null, {headers});
  }

  public deleteOrder(id: number): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/orders/delete/${id}`, {headers});
  }
  public orderDetails(id: number): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/orders/${id}`, {headers});
  }

  public myFavorites(page: number): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/favorites/product?page=${page}`, {headers});
  }
  public setMainAddress(addressId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/addresses/set-main/${addressId}`,null, {headers});
  }
  public deleteAddress(addressId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/addresses/delete/${addressId}`, {headers});
  }
  public resetPassword(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}auth/password/reset`,body, {headers});
  }
  public verifyOtp(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}auth/password/verify_otp`,body, {headers});
  }
  public resentOtp(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.token}`,
      // 'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}auth/password/resend_otp`,body, {headers});
  }
  public updatePassword(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}auth/password/update`,body, {headers});
  }
  public countries(page: number): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}app/countries?page=${page}`, {headers});
  }
  public addAddress(body: any): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/addresses/add`,body, {headers});
  }

  // cart functions
  public addToCart(body: any): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/cart/add`,body, {headers});
  }
  public getCart(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/cart`, {headers});
  }
  public getCartCustomProducts(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}my/cart/custom`, {headers});
  }
  public removeCartItem(itemId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/cart/remove/${itemId}`, {headers});
  }
  public removeCustomCartItem(itemId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/cart/remove/custom/${itemId}`, {headers});
  }
  public emptyCart(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.delete(`${this.baseUrl}my/cart/empty`, {headers});
  }
  public confirmOrder(body: any): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/orders/confirm`,body, {headers});
  }
  public confirmOrderWithoutToken(body: any): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/orders/confirm-guest`,body, {headers});
  }

  public vendorSettings(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}vendor/1/settings`, {headers});
  }
  public orderApss(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}partnervendors`, {headers});
  }
  public applyCoupon(body: any): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}copon`,body, {headers});
  }

  public offers(page: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}app/offers?page=${page}`, {headers});
  }

  public paymentMethod(body: any): Observable<any> {
    return this.http.post(`${this.payment}`, body);
  }

  public updatePaymentState(body: any,orderId: string): Observable<any> {
    this.checkExpiration()
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': 'en'
    });
    return this.http.post(`${this.baseUrl}my/orders/payment-state/${orderId}`,body, {headers});
  }

  public getFoodCategories(): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}app/main/custom-plates-categories`, { headers: headers });
  }

  public getFoodSubCategories(catId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}app/custom/plates-subcategories/${catId}`, { headers: headers });
  }

  public getFoodTopics(catId: number,subCatId: number): Observable<any> {
    this.checkExpiration()
     const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
      'auth-token': `${this.token}`,
      'locale': 'en'
    });
    return this.http.get(`${this.baseUrl}app/custom/topics/${catId}/${subCatId}`, { headers: headers });
  }
}
